function Heading({ level, className, id, children }) {
  const HeadingTag = `h${level}`;
  return (
    <HeadingTag className={className} id={id}>
      {children}
    </HeadingTag>
  );
}

export default function ApplicationViewHeader({
  title,
  titleId,
  headingLevel = 1,
  variant = 'ordinary',
  contextLabel,
  backNavigation,
  description,
  metadata,
  actions,
  className = '',
}) {
  if (!['ordinary', 'operational'].includes(variant)) {
    throw new Error(`Unsupported ApplicationViewHeader variant: ${variant}`);
  }

  const classes = [
    'av-app-view-header',
    `av-app-view-header--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <header className={classes}>
      <div className="av-app-view-header__copy">
        {backNavigation && (
          <div className="av-app-view-header__back">
            {backNavigation}
          </div>
        )}

        {contextLabel && (
          <p className="av-app-view-header__context">
            {contextLabel}
          </p>
        )}

        <Heading
          className="av-app-view-header__title"
          id={titleId}
          level={headingLevel}
        >
          {title}
        </Heading>

        {description && (
          <p className="av-app-view-header__description">
            {description}
          </p>
        )}

        {metadata && (
          <div className="av-app-view-header__metadata">
            {metadata}
          </div>
        )}
      </div>

      {actions && (
        <div className="av-app-view-header__actions">
          {actions}
        </div>
      )}
    </header>
  );
}
